


































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { VeeValidateObserverRef } from '@/models/Common/Validation'
import UserService from '@/services/UserService'

@Component
export default class ShowCompanyInfo extends Vue {
  @Prop() companyInfo!: any
  $refs!: {
    observer: VeeValidateObserverRef
  }
  showCompanyInfo: boolean = true

  async postcodeSearch(isError: string) {
    if (isError) {
      return
    }

    try {
      const res = await UserService.getZipCode(this.companyInfo.zipcode)
      this.$emit('onPostCodeSearch', {
        prefecture: res.data.province_name,
        city: res.data.district_name,
        other_address: res.data.city_name
      })
    } catch (err) {
      console.log(err)
    }
  }

  updateCompanyInfo() {
    this.$refs.observer.validate().then(isValidate => {
      if (!isValidate) {
        return
      } else {
        const new_company_info = {
          company_info_display_option: this.companyInfo.company_info_display_option,
          company_name: this.companyInfo.company_name,
          department: this.companyInfo.department,
          job_title: this.companyInfo.job_title,
          zipcode: this.companyInfo.zipcode,
          prefecture: this.companyInfo.prefecture,
          city: this.companyInfo.city,
          other_address: this.companyInfo.other_address,
          building_name: this.companyInfo.building_name,
          phone: this.companyInfo.phone,
          url: this.companyInfo.url
        }
        this.$emit('onUpdateCompanyInfo', new_company_info)
      }
    })
  }

  addPhoneNumberField() {
    if (this.companyInfo.phone.length < 10) {
      this.$emit('onAddPhoneNumberField')
    }
  }

  addUrlField() {
    if (this.companyInfo.url.length < 10) {
      this.$emit('onAddUrlField')
    }
  }

  removePhoneNumberField(index: any) {
    this.$emit('onRemovePhoneNumberField', index)
  }

  removeUrlField(index: any) {
    this.$emit('onRemoveUrlField', index)
  }

  updateCompanyField({
    field,
    index,
    value
  }: {
    field: string
    index?: number
    value: any
  }) {
    const updated = { ...this.companyInfo }

    if (index !== undefined) {
      updated[field] = [...updated[field]]
      updated[field][index] = value
    } else {
      updated[field] = value
    }

    this.$emit('updateCompanyField', updated)
  }

  onZipCodeInputNumberOnly(event: any) {
    const raw = event.target.value.replace(/[^0-9０-９]/g, '')

    const normalized = raw.replace(/[０-９]/g, (s: string) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )

    event.target.value = normalized
    this.updateCompanyField({
      field: 'zipcode',
      value: event.target.value
    })
  }

  onPhoneNumberInputNumberOnly(event: any, index: number) {
    let value = event.target.value.replace(/[^0-9０-９]/g, '')

    value = value.replace(/[０-９]/g, (s: string) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )

    event.target.value = value
    this.updateCompanyField({
      field: 'phone',
      index,
      value: event.target.value
    })
  }
}
